import Backbone from 'backbone'
import _ from 'lodash'
import metadata from 'scoreboard/components/metadata'
import nestModel from 'scoreboard/components/nest-model'
import ChartDesigner from './chart-designer'
import ChartData from '../chart-data/chart-data'
import permissions from 'scoreboard/components/permissions'

const Chart = Backbone.Model.extend({
	section: 'charts',
	domainType: 'chart',
	urlRoot: 'api/charts',

	initialize: function (attr) {
		this.chartDesigner = new ChartDesigner(this.get('chartDesigner'), {
			data: this.data
		})
		this.data = this.data || this.chartDesigner.data
		nestModel({
			parent: this,
			parentAttribute: 'chartDesigner',
			child: this.chartDesigner
		})
	},

	/**
	 * @override
	 */
	parse: function(resp, options) {
		if (this.data) {
			this.data.set(resp.chartData)
		} else {
			this.data = new ChartData({data: resp.chartData})
		}

		if (this.chartDesigner) {
			this.chartDesigner.data = this.data
		}

		return _.omit(resp, 'chartData')
	},

	/**
	 * Adaptation of Backbone.Model.toJSON() that leaves out attributes that
	 * don't need to be sent to the server. See ChartDesigner.toPostJSON() for
	 * details
	 */
	toPostJSON: function () {
		let c = _.omit(this.toJSON(), 'chartDesigner')
		c.chartDesigner = this.chartDesigner.toPostJSON()
		return c
	},

	isEditable: function() {
		return permissions.reports(this.get('organizationId'))
			&& permissions.isEditableIfReplicated(this)
	}
})

/**
 * Creates a new chart tree item with a blank ChartDesigner
 */
Chart.create = function ({ organizationId, relativeId }) {
	return new Chart({
		relativeId,
		organizationId,
		type: 'chart',
		icon: metadata['charts'].sectionIcon,
		section: 'charts',
		chartDesigner: {}
	})
}

export default Chart

Chart.__filename__ = 'charts/model/chart.js'
